class ProductAddition extends HTMLElement {
  constructor() {
    super();

    this.variantSelect = this.querySelector(".js-variant-select");
    this.input = this.querySelector(".js-product-addition");
    this.option1 = this.querySelector(".js-option-select-1");
    this.option2 = this.querySelector(".js-option-select-2");
    this.option3 = this.querySelector(".js-option-select-3");

    this.selectedVariantId = this.variantSelect.value;

    this.getSelectedVariant();
    this.fetchVariantPrice();

    this.options = this.querySelectorAll(".js-complete-set-option");
    this.options.forEach((option) => {
      option.addEventListener("change", () => {
        this.getSelectedVariant();
        this.fetchVariantPrice();
        this.input.value = this.selectedVariantId;
      });
    });
  }

  fetchVariantPrice() {
    fetch(`${this.dataset.url}?section_id=main-product&variant=${this.selectedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const saleRegularSource = html.querySelector(".price__sale span > .price-item");
        const saleRegularDestination = this.querySelector(".price__sale span > .price-item");
        saleRegularDestination.innerHTML = saleRegularSource.innerHTML;

        const salePriceSource = html.querySelector(".price__sale .price-item");
        const salePriceDestination = this.querySelector(".price__sale .price-item");
        salePriceDestination.innerHTML = salePriceSource.innerHTML;

        const priceSource = html.querySelector(".price__regular .price-item");
        const priceDestination = this.querySelector(".price__regular .price-item");
        priceDestination.innerHTML = priceSource.innerHTML;
      });
  }

  getSelectedVariant() {
    const option1Value = this.option1 ? this.option1.value : null;
    const option2Value = this.option2 ? this.option2.value : null;
    const option3Value = this.option3 ? this.option3.value : null;

    const variants = this.variantSelect.querySelectorAll("option");
    variants.forEach((variantOption) => {
      const variantOption1Value = variantOption.getAttribute("data-option-1")
        ? variantOption.getAttribute("data-option-1")
        : null;
      const variantOption2Value = variantOption.getAttribute("data-option-2")
        ? variantOption.getAttribute("data-option-2")
        : null;
      const variantOption3Value = variantOption.getAttribute("data-option-3")
        ? variantOption.getAttribute("data-option-3")
        : null;

      if (
        variantOption1Value == option1Value &&
        variantOption2Value == option2Value &&
        variantOption3Value == option3Value
      ) {
        this.selectedVariantId = variantOption.getAttribute("value");
      }
    });
  }
}

customElements.define("product-addition", ProductAddition);
